import { Box, Tab, Tabs } from '@mui/material'
import React from 'react'

import { isNullorEmpty } from '@/utils'

import DentinRecipe from './DentinRecipe'
import EnamelRecipe from './EnamelRecipe'
import StainingAndWashBakeRecipe from './StainingAndWashBakeRecipe'
import StumpShadeRecipe from './StumpShadeRecipe'

interface RecipeTabContainerProps {
  selectedTab: string
  handleTabChange: (event: React.SyntheticEvent, newValue: string) => void
  recipeOutput: any
  restorationMethodOnRecipeGenerate?: string
  options?: any
}

const tabStyles = {
  color: '#999',
  textTransform: 'none',
  '&.Mui-selected': {
    color: '#90CAF9',
  },
  padding: '16px 32px',
  fontSize: '16px',
  fontWeight: 700,
  fontFamily: "'Inter'",
}

function RecipeTabContainer({
  selectedTab,
  handleTabChange = () => {},
  recipeOutput,
  restorationMethodOnRecipeGenerate,
  options,
}: RecipeTabContainerProps) {
  return (
    <Box
      flex={7}
      sx={{
        height: 'fit-content',
      }}
      display="flex"
      flexDirection="column"
      gap="32px"
    >
      <Tabs
        value={selectedTab}
        onChange={handleTabChange}
        variant="scrollable"
        sx={{
          borderBottom: '1px solid rgba(255, 255, 255, 0.2)',
        }}
      >
        {options?.map(({ conditionKey, method, label }) => {
          const shouldRender =
            (conditionKey && recipeOutput?.[conditionKey]) ||
            (method && restorationMethodOnRecipeGenerate === method)

          return shouldRender ? (
            <Tab key={label} label={label} value={label} sx={tabStyles} />
          ) : null
        })}
      </Tabs>

      {selectedTab === 'Stump Shade' &&
        isNullorEmpty(recipeOutput, 'aestheticmodel_middle') && (
          <StumpShadeRecipe
            recipeOutput={recipeOutput}
            natural_die_material={
              recipeOutput?.provided_input?.natural_die_material
            }
          />
        )}

      {(selectedTab === 'Wash Bake' || selectedTab === 'Staining') &&
        (restorationMethodOnRecipeGenerate === 'layering' ||
          restorationMethodOnRecipeGenerate === 'staining') &&
        isNullorEmpty(recipeOutput, 'stainingrecipe_middle') && (
          <StainingAndWashBakeRecipe
            recipeOutput={recipeOutput}
            stainingbrand={recipeOutput?.provided_input?.stainingbrand}
            restorationMethodOnRecipeGenerate={
              restorationMethodOnRecipeGenerate
            }
          />
        )}
      {selectedTab === 'Dentin' &&
        isNullorEmpty(recipeOutput, 'ceramic_recipe_middle') && (
          <DentinRecipe
            recipeOutput={recipeOutput}
            brand={recipeOutput?.provided_input?.ceramicbrand}
          />
        )}
      {selectedTab === 'Enamel' &&
        isNullorEmpty(recipeOutput, 'enameloptions_middle') && (
          <EnamelRecipe
            recipeOutput={recipeOutput}
            brand={recipeOutput?.provided_input?.ceramicbrand}
          />
        )}
    </Box>
  )
}

export default RecipeTabContainer
